import React, { Component } from 'react';
import './App.css';

import Header from 'components/header/Header'
import Footer from 'components/footer/Footer'
import Dashboard from 'components/dashboard/Dashboard'
import { datadb, admindb } from 'db'

class App extends Component {
  state = {
    authenticated: false
  };

  componentDidMount() {
    admindb.authenticateApp().then(() =>
      datadb.authenticateApp().then(() => {
        this.setState({ authenticated: true})
      }))
  }


  render() {
    const { authenticated } = this.state;

    return (
      <div className="main">
        <Header />
        <div className="main-body">
          { authenticated && <Dashboard/> }
	        { !authenticated && <span>Authenticating...please wait</span> }
        </div>
        {<Footer />}
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js